export const shouldLoad = () => document.querySelector('.klt-dynamic-block__content--cards') !== undefined;